module.exports = __webpack_public_path__ + "img/Picture12.952e018d.jpg";